import type { ReactNode } from 'react';

import type { CLICK_PIX_BUTTON_VARIANT } from '@woovi/ui';
import { ClickPixButton } from '@woovi/ui';

type Props = {
  onClick?: () => void;
  variant?: CLICK_PIX_BUTTON_VARIANT;
};
export const WooviPayButton = ({ onClick, variant }: Props): ReactNode => {
  return (
    <ClickPixButton
      variant={variant}
      data-testid='woovi-pay-button'
      onClick={onClick}
    />
  );
};
